import React from "react";
import Title from "../../ui/Title";

const HouseHolds = () => {
  return (
    <div id="caregiving-multigenerational-households" className="scroll-mt-24">
      <Title
        title="Caregiving in multigenerational households"
        className="mb-6"
      />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          According to the{" "}
          <a
            href="https://www.socialworktoday.com/archive/070714p14.shtml"
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            2014 article
          </a>{" "}
          <span className="italic">Caregiving in Multigenerational Homes,</span>{" "}
          caregiving in multigenerational households can bring an array of
          challenges due to the complexity of such environments. Often, extreme
          limitations are placed on one’s life when taking care of another
          person in these scenarios. . For example, someone in the ‘sandwich
          generation’ who has to take care of an aging parent and children
          within a multigenerational household, faces a multitude of challenges
          balancing their work, personal life, and the needs of multiple
          people.. Another example is a grandparent who has to take care of
          grandchildren since the parents are unable to provide care for them
          maybe due to an illness or substance use. In these cases, challenges
          can often arise when it comes to decision-making, such as,
          disagreements over authority, caregiving roles, or decisions related
          to children and household management.
        </p>

        <p>
          Given these complexities, caregiving in multigenerational households
          needs targeted attention. Supportive interventions must account for
          family dynamics and environments in order to effectively address the
          unique challenges faced by caregivers in these households.
        </p>

        <p>
          Countries in South and Southeast Asia (including countries we work
          in), traditionally have a large number of multigenerational
          households.{" "}
          <a
            href="https://www.ilc-alliance.org/wp-content/uploads/publication-pdfs/Global_Alliance_Intergenerational_Relations_March_2012.pdf"
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            A 2012 report
          </a>{" "}
          by International Longevity Centre Global Alliance states that
          approximately 60 percent of families in rural India and 30 percent
          percent of families in urban India live in multigenerational
          households.
        </p>

        <p>
          Data from a{" "}
          <a
            href="https://www.pewresearch.org/social-trends/2022/03/24/financial-issues-top-the-list-of-reasons-u-s-adults-live-in-multigenerational-homes/"
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            PEW Research Center report
          </a>{" "}
          suggests that the number of multigenerational households in the United
          States has risen sharply over the last decade. While the share of
          multigenerational households has been rising since 1971, they
          accelerated sharply during the COVID-19 pandemic, when many people
          moved to live with their families. Many have continued the living
          arrangement even post-pandemic. Additionally, financial pressures,
          including the high cost of living and student loan debt, have also
          contributed to this shift, with more people choosing to live in family
          homes in multigenerational settings. Many people also live in
          multigenerational households to provide caregiving support.
        </p>

        <p>
          According to the{" "}
          <a
            href="https://www.census.gov/library/stories/2023/06/several-generations-under-one-roof.html"
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            US Census Bureau
          </a>
          , the percentage of multigenerational households in the United States
          increased from 4.2% in 2010 to 7.2 percent in 2020.
        </p>

        <div className="flex flex-col items-center gap-2">
          <div className="!mt-6">
            <img
              src="/assets/img/population.png"
              alt="U.S. population in multigenerational households quadrupled since 1971"
            />
          </div>
        </div>

        <div className="flex flex-col items-center">
          <div className="">
            <img
              src="/assets/img/pew-research.png"
              alt="For many, multigenerational living has practical reasons and emotional results"
            />
          </div>
          <p className="text-center">
            <a
              href="https://www.pewresearch.org/social-trends/2022/03/24/financial-issues-top-the-list-of-reasons-u-s-adults-live-in-multigenerational-homes/"
              className="text-blue underline italic"
              target="_blank"
              rel="noopener noreferrer"
            >
              Source: Pew Research Center
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HouseHolds;
